import { useQuery } from 'react-query'
import { initTransaction } from 'services/loans'

export default function useSetInitTransaction(id: number) {
    const { data, isLoading } = useQuery(
        ['init-transaction', id],
        initTransaction
    )
    return { data, isLoading }
}
